<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless">
    <div class="column is-12 pdh-30px pdb-0 hauteur-haut-ressource">
      <div class="level border-entete">
        <div class="level-left">
          <p class="has-text-link is-size-4 has-text-weight-bold">
            {{ $t('chargeTravailTech.ressourceAndAffectationInfo.title') }}
          </p>
        </div>
        <div class="level-right is-cursor-pointer">
          <div @click="$emit('close')">
            <b-icon icon="close"
                    type="is-link"
                    size="is-small"
                    class="mgv-auto"></b-icon>
          </div>
        </div>
      </div>
      <div class="columns">
        <b-datepicker show-week-number
                      :disabled="critereRecherche.sansDatePremierAffichage === true"
                      icon="calendar-today"
                      class="column is-5 pdt-0"
                      range
                      @input="updateDates()"
                      v-model="dates"
                      :date-parser="parser"
                      nearby-selectable-month-days
                      :editable="true">
        </b-datepicker>
        <div class="column is-7 pdt-0 mgv-auto has-text-right">
          <qd-switch v-model="critereRecherche.sansDatePremierAffichage"
                    @input="$emit('recherche')">
            <p class="has-text-default">
              {{ $t('chargeTravailTech.sansDate') }}
            </p>
          </qd-switch>
        </div>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless is-paddingless
    hauteur-ressource-information" v-if="ressources.length > 0">
      <div class="pdh-30px pdb-20px is-cursor-pointer"
           @click="$emit('updateTechnicienSelect', null)">
        <div :class="{ 'outline-primary-total' : technicienSelect === null }"
             class="mgt-5px">
          <technicienTitle :technicienInformation="{
          technicienId: null,
          technicien: $t('chargeTravailTech.ressourceAndAffectationInfo.otNonAffecte'),
          nbOts: nbOtSansTechnicien,
          }"
                          :firstLigne="true">
          </technicienTitle>
        </div>
      </div>
      <div v-for="(techInfo, index) in ressources" :key="index">
        <div class="pdh-30px pdb-20px is-cursor-pointer"
             @click="$emit('updateTechnicienSelect', techInfo.technicienId)">
          <div :class="{
            'outline-primary-total' : technicienSelect === techInfo.technicienId
          }">
            <technicien-title v-if="techInfo.technicien"
                            :firstLigne="false"
                            :technicien-information="techInfo"
            ></technicien-title>
            <informations-liste-a-date :ressource-a-date="techInfo.dateList">
            </informations-liste-a-date>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="hauteur-ressource-information column is-12 pdh-30px is-flex">
      <div class="has-text-centered mgv-auto no-box-shadow-card width-100percent">
        <div  class="card card-content has-text-centered border-color-select">
          <h1 class="title is-size-4">
            {{ $t('chargeTravailTech.ressourceAndAffectationInfo.noCharge')}}
          </h1>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-ressourceAffectation">
      <button @click="$emit('close')"
              class="button mgt-15px is-size-7 has-text-link">
        {{ $t('general.button.close') }}
      </button>
    </div>
  </div>
</template>

<script>

import technicienTitle from '@/components/logistique/chargeTravail/tech/ressource/technicienTitle';
import informationsListeADate
  from '@/components/logistique/chargeTravail/tech/ressource/informationsListeADate';
import stringToDate from '@/services/logistique/chargeTravail/technique/stringToDate';

export default {
  props: {
    critereRecherche: {
      type: Object,
      required: true,
    },
    ressources: {
      required: true,
      type: Array,
    },
    nbOtSansTechnicien: {
      required: true,
      type: Number,
    },
    technicienSelect: {
      required: false,
      type: String,
    },
  },
  data() {
    return {
      dates: [],
    };
  },
  components: {
    technicienTitle,
    informationsListeADate,
  },
  methods: {
    updateDates() {
      this.$emit('updateDates', this.dates[0], this.dates[1]);
    },
    parser(dateRange) {
      if (dateRange === '' || !dateRange) {
        this.changementDateFromParent();
        return this.dates;
      }
      const [dateDebut, dateFin] = dateRange.split('-');
      const startDate = stringToDate(dateDebut);
      const endDate = stringToDate(dateFin);
      if (startDate && !endDate) {
        return [startDate, startDate];
      }
      if (!startDate && endDate) {
        return [endDate, endDate];
      }
      if (!startDate && !endDate) {
        this.changementDateFromParent();
        return this.dates;
      }
      return [startDate, endDate];
    },
    changementDateFromParent() {
      this.dates = [
        this.critereRecherche.datesPremierAffichage.dateDebut.toDate(),
        this.critereRecherche.datesPremierAffichage.dateFin.toDate(),
      ];
    },
  },
  mounted() {
    this.changementDateFromParent();
  },
};

</script>
